﻿window.cAdresse = function(value) {
    if (typeof value == 'undefined' || value == null) {
        value.ad1 = ""
        value.ad2 = ""
        value.ad3 = ""
        value.cp = ""
        value.ville = ""
        value.cedex = ""
        value.dpt = ""
        value.region = ""
        value.pays = ""
        value.code_pays = ""
        value.latitude = ""
        value.longitude = ""
        value.normalise = 0
    }

    this.hasAdresse = function () {
        return (value.ad1 != null && value.ad1.length > 0) ||
            (value.ad2 != null && value.ad2.length > 0) ||
            (value.ad3 != null && value.ad3.length > 0) ||
            (value.cp != null && value.cp.length > 0) ||
            (value.ville != null && value.ville.length > 0) ||
            (value.cedex != null && value.cedex.length > 0) ||
            (value.dpt != null && value.dpt.length > 0) ||
            (value.region != null && value.region.length > 0) ||
            (value.pays != null && value.pays.length > 0)
    }

    this.mGetCpVilleCedexPays = function () {
        var txt = ((value.cp == null) ? "" : value.cp)
        if (value.ville != null && value.ville.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.ville
        }
        if (value.cedex != null && value.cedex.length > 0) {
            if (txt.length > 0) txt += " "
            txt += value.cedex
        }
        if (value.pays != null && value.pays.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.pays
        }
        return txt
    }

    this.mGetAdresseCourt = function () {
        var txt = this.mGetCpVilleCedexPays()
        if (txt.length == 0) txt = this.mGetLibelleLong()
        return txt
    }

    this.mGetLibelleCourt = function () {
        //if (value.normalise == 0) { return ((value.ad1 == null) ? "" : value.ad1) }
        //else {
        var txt = ((value.ad1 == null) ? "" : value.ad1)
        if (value.ville != null && value.ville.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.ville
        }
        if (value.pays != null && value.pays.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.pays
        }
        return txt
        //}
    }

    this.mGetAdresseRue = function () {
        var txt = ((value.ad1 == null) ? "" : value.ad1)
        if (value.ad2 != null && value.ad2.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.ad2
        }
        if (value.ad3 != null && value.ad3.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.ad3
        }
        return txt
    }

    this.mGetLibelleLong = function (afficheDpt, afficheRegion) {
        if (typeof afficheRegion == 'undefined') afficheRegion = false
        if (typeof afficheDpt == 'undefined') afficheDpt = false
        //if (value.normalise == 0) { return ((value.ad1 == null) ? "" : value.ad1) }
        //else {
        var txt = ((value.ad1 == null) ? "" : value.ad1)
        if (value.ad2 != null && value.ad2.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.ad2
        }
        if (value.ad3 != null && value.ad3.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.ad3
        }
        if (value.cp != null && value.cp.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.cp
        }
        if (value.ville != null && value.ville.length > 0) {
            if (txt.length > 0) if (value.cp != null && value.cp.length > 0) { txt += " " } else { txt += ", " }
            txt += value.ville
        }
        if (afficheDpt && value.dpt != null && value.dpt.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.dpt
        }
        if (afficheRegion && value.region != null && value.region.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.region
        }
        if (value.pays != null && value.pays.length > 0) {
            if (txt.length > 0) txt += ", "
            txt += value.pays
        }
        return txt
        //}
    }

    this.mGetAffichageMultilineElement = function () {
        var $Div = $("<div/>")
        if (value.ad1 != null && value.ad1.length > 0) $("<div><span style=''>" + value.ad1 + "</span></div>").appendTo($Div)
        if (value.ad2 != null && value.ad2.length > 0) $("<div><span style=''>" + value.ad2 + "</span></div>").appendTo($Div)
        if (value.ad3 != null && value.ad3.length > 0) $("<div><span style=''>" + value.ad3 + "</span></div>").appendTo($Div)
        $("<div><span style=''>" + this.mGetCpVilleCedexPays() + "</span></div>").appendTo($Div)
        return $Div
    }

    this.mGetAffichage1lineElement = function () {
        var $Div = $("<span/>")
        if (value.ad1 != null && value.ad1.length > 0) $("<span style=''>" + value.ad1 + "</span>").appendTo($Div)
        if (value.ad2 != null && value.ad2.length > 0) $("<span style=''>, " + value.ad2 + "</span>").appendTo($Div)
        if (value.ad3 != null && value.ad3.length > 0) $("<div><span style=''>, " + value.ad3 + "</span>").appendTo($Div)
        $("<span style=''>, " + this.mGetCpVilleCedexPays() + "</span>").appendTo($Div)
        return $Div
    }

    this.hasValue = function () {
        return this.hasAdresse()
    }


}